var React = require('react');

function ImgTel (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.64 22.2403L24.9067 18.5203C23.5733 17.187 21.3067 17.7203 20.7733 19.4537C20.3733 20.6537 19.04 21.3203 17.84 21.0537C15.1733 20.387 11.5867 16.9337 10.92 14.147C10.52 12.947 11.32 11.627 12.52 11.227C14.2533 10.6937 14.7867 8.44034 13.4533 7.10701L9.72001 3.38701C8.65334 2.45368 7.05334 2.45368 6.12001 3.38701L3.60001 5.89368C1.06667 8.54701 3.86667 15.6003 10.12 21.8403C16.3733 28.0803 23.44 31.0137 26.1067 28.347L28.64 25.827C29.56 24.7603 29.56 23.1737 28.64 22.2403Z","fill":"#223344"}));
}

ImgTel.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ImgTel;

ImgTel.default = ImgTel;
